import {UI, Button, registerStyle, styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/UI";
import {BUTTON_TYPE} from "../../../../../Constants";

export class SubscribeButtonStyle extends StyleSheet {
    common = {
        padding: 10,
        borderRadius: () => this.themeProps.MERCHANT_BUTTON_INPUT_TOAST_BORDER_RADIUS,
        outline: 0,
        fontSize: () => this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        fontWeight: () => this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        cursor: "pointer",
        transition: ".3s ease",
        "-webkit-user-select": "none",
        userSelect: "none",
        display: "inline-block",
        border: "none",
        ":disabled": {
            color: () => this.themeProps.MERCHANT_BUTTON_PRIMARY_DISABLED_COLOR,
            cursor: "not-allowed",
        }
    };

    @styleRule
    primaryButton = {
        ...this.common,
        color: this.themeProps.MERCHANT_BUTTON_PRIMARY_TEXT_COLOR,
        background: this.themeProps.MERCHANT_BUTTON_PRIMARY_BACKGROUND,
        boxShadow: "none",
        textShadow: "none",
        border: () => "1px solid " + this.themeProps.MERCHANT_BUTTON_PRIMARY_BORDER_COLOR,
        ":hover": {
            background: this.themeProps.MERCHANT_BUTTON_PRIMARY_BACKGROUND_HOVER,
            borderColor: this.themeProps.MERCHANT_BUTTON_PRIMARY_BORDER_COLOR_HOVER,
        },
    };

    @styleRule
    secondaryButton = {
        ...this.common,
        color: this.themeProps.MERCHANT_BUTTON_SECONDARY_TEXT_COLOR,
        background: this.themeProps.MERCHANT_BUTTON_SECONDARY_BACKGROUND,
        border: "1px solid " + this.themeProps.MERCHANT_BUTTON_SECONDARY_BORDER_COLOR,
        ":hover": {
            background: this.themeProps.MERCHANT_BUTTON_SECONDARY_BACKGROUND_HOVER,
            borderColor: this.themeProps.MERCHANT_BUTTON_SECONDARY_BORDER_COLOR_HOVER,
        },
    };

    Size() {}
    Level() {}
}

@registerStyle(SubscribeButtonStyle)
export class SubscribeButton extends Button {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            type: BUTTON_TYPE.PRIMARY,
        }
    }
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        const {styleSheet} = this;
        attr.addClass(this.options.type === BUTTON_TYPE.PRIMARY ? styleSheet.primaryButton : styleSheet.secondaryButton);
    }
}
